module.exports = __webpack_public_path__ + "6820b17f8018ce6a61ace342dad10493.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/favicons/apple_touch_icon_72x72.png
// module id = 311
// module chunks = 0